export default __webpack_public_path__ + "assets/bg-image-1_1bg-image-1.0f81c752.avif";